import { useNavigate } from "react-router-dom";
import WebsiteNavbar from "../components/WebsiteNavbar";
import Footer from "../components/Footer";
import "../style/commercial.css";

const Commercial = () => {
  const navigate = useNavigate();

  return (
    <>
      <WebsiteNavbar />

      <div className="commercial-page">

        {/* ── Hero ── */}
        <section className="comm-hero">
          <div className="comm-hero-inner">
            <p className="comm-eyebrow">Commercial Services</p>
            <h1>
              Reliable Skip Bin Services for <span className="comm-accent">Businesses</span>
            </h1>
            <p className="comm-hero-sub">
              From local contractors to large enterprises, we deliver reliable waste solutions tailored to your business.
            </p>
            <div className="comm-hero-actions">
              <button className="comm-btn-primary" onClick={() => navigate("/commercial-quotes")}>
                Request a Quote
              </button>
              <button className="comm-btn-outline" onClick={() => navigate("/booking")}>
                Book Bin Now
              </button>
            </div>
          </div>
          <div className="comm-hero-slash" />
        </section>

        {/* ── Stats Band ── */}
        <section className="comm-stats">
          <div className="comm-stats-inner">
            <div className="comm-stat">
              <span className="stat-num">500+</span>
              <span className="stat-label">Commercial Projects</span>
            </div>
            <div className="comm-stat">
              <span className="stat-num">24 / 7</span>
              <span className="stat-label">Support Available</span>
            </div>
            <div className="comm-stat">
              <span className="stat-num">98%</span>
              <span className="stat-label">Satisfaction Rate</span>
            </div>
            <div className="comm-stat">
              <span className="stat-num">Same Day</span>
              <span className="stat-label">Delivery Available</span>
            </div>
          </div>
        </section>

        {/* ── Features ── */}
        <section className="comm-features">
          <div className="comm-section-inner">
            <p className="comm-section-label">Why Businesses Choose Us</p>
            <h2 className="comm-section-title">
              Everything your project needs,<br />delivered without the hassle.
            </h2>

            <div className="comm-feature-grid">

              <div className="comm-feature-card">
                <div className="feat-icon">📅</div>
                <h3>Long-Term Hire</h3>
                <p>
                  Flexible weekly and monthly contracts for ongoing
                  construction, retail fit-outs, and site clearances.
                </p>
              </div>

              <div className="comm-feature-card">
                <div className="feat-icon">🚚</div>
                <h3>Priority Collection</h3>
                <p>
                  Scheduled pickups that fit your timeline. Same-day
                  delivery available across our service area.
                </p>
              </div>

              <div className="comm-feature-card">
                <div className="feat-icon">💰</div>
                <h3>Volume Pricing</h3>
                <p>
                  Custom quotes based on bin size, waste type, and hire
                  duration. No hidden charges ever.
                </p>
              </div>

              <div className="comm-feature-card">
                <div className="feat-icon">♻️</div>
                <h3>Responsible Disposal</h3>
                <p>
                  We sort and divert waste from landfill wherever possible,
                  with compliance documentation on request.
                </p>
              </div>

            </div>
          </div>
        </section>

        {/* ── CTA ── */}
          <div className="comm-cta-inner">
  <h2>
    Need a custom <br />
    <span className="comm-accent">
      waste management
    </span>{" "}
    plan?
  </h2>

  <p>
    Our team will assess your requirements and deliver a tailored quote for your project.
  </p>

  <button
    className="comm-btn-primaryy"
    onClick={() => navigate("/commercial-quotes")}
  >
    Get a Commercial Quote
  </button>
</div>

      </div>

      <Footer />
    </>
  );
};

export default Commercial;